module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc2-d04071c82a3d89ef9057e214967eb4ab.jpg";